import { EE } from './../utils/ee';
import { eventFrom } from 'event-from';

class CardCursor {
  constructor(root) {
    this.root = root;

    const mode = this.root.getAttribute('data-card-cursor');
    this.mode = mode === '' ? null : mode;

    this.bind();
  }

  bind() {
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);

    this.root.addEventListener('mouseenter', this.onMouseEnter);
    this.root.addEventListener('mouseleave', this.onMouseLeave);
  }

  onMouseEnter(e) {
    if (eventFrom(e) !== 'mouse') { return }

    EE.emit('enter-card', { ctx: 'cursor', mode: this.mode });
  }

  onMouseLeave(e) {
    if (eventFrom(e) !== 'mouse') { return }

    EE.emit('leave-card', { ctx: 'cursor' });
  }

  unbind() {
    this.root.removeEventListener('mouseenter', this.onMouseEnter);
    this.root.removeEventListener('mouseleave', this.onMouseLeave);
  }

  destroy() {
    this.anim && this.anim.kill();
  }
}

export default {
  when() {
    return document.querySelectorAll('[data-card-cursor]').length > 0;
  },

  created() {
    this.instances = [];
    document.querySelectorAll('[data-card-cursor]').forEach(card => {
      const instance = new CardCursor(card);
      this.instances.push(instance);
    });
  },

  destroyed() {
    this.instances.forEach(instance => {
      instance.destroy && instance.destroy();
    });
  }
}
